import { render } from "./AiResponseMessage.vue?vue&type=template&id=0d5085cb&scoped=true"
import script from "./AiResponseMessage.vue?vue&type=script&lang=js"
export * from "./AiResponseMessage.vue?vue&type=script&lang=js"

import "./AiResponseMessage.vue?vue&type=style&index=0&id=0d5085cb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5085cb"]])

export default __exports__